import { handle } from './wrapper.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'

const handler = (input, select) => {
  const { selectedIndex, selectedOptions } = select

  replaceChildren(selectedOptions[selectedIndex], input.value)
}

export default input => {
  handle(input, handler)
}